import { EntityRepository, Repository } from "typeorm";
import { SOTransferLog } from "../so-transfer-log.entity";

@EntityRepository(SOTransferLog)
export class SOTransferLogRepository extends Repository<SOTransferLog> {


}